import { getNormalizedList } from '../utils/apiUtils';

const getApiRequest = (resourceType, params = { page: { size: 25 } }) => {
  return getNormalizedList(`${process.env.REACT_APP_API_URL}/api/${resourceType}`, params);
}

class CommonDataService {

  static getAvailabilityTypes() {
    return getApiRequest('availabilitytypes');
  }

  static getLanguages() {
    return getApiRequest('languages');
  }

  static getLocations() {
    return getApiRequest('officelocations');
  }

  static getServerLocations() {
    return getApiRequest('serverlocations');
  }

  static getTeams() {
    return getApiRequest('teams');
  }

  static getProjectRoles() {
    return getApiRequest('projectroles');
  }

  static getCountries(params) {
    return getApiRequest('countries', params);
  }

  static getProjectStatusTypes() {
    return getApiRequest('projectstatustypes');
  }

  static getRoles() {
    return getApiRequest('roles');
  }

  static getCompletionStatusTypes() {
    return getApiRequest('completionstatustypes');
  }

  static getDecipherTypes() {
    return getApiRequest('deciphertypes');
  }

  static getAccountTypes() {
    return getApiRequest('accounttypes');
  }

  static getServiceTypes() {
    return getApiRequest('servicetypes');
  }

  static getVideoProjectTypes() {
    return getApiRequest('videoprojecttypes');
  }
}

export default CommonDataService;



// WEBPACK FOOTER //
// ./src/services/CommonDataService.js